const PanelSizes = {
  main: {
    order: 1,
    min: 30,
    max: 100,
    defaultSize: 100,
  },
  sidebar: {
    order: 2,
    min: 25,
    max: 70,
    defaultSize: 30,
  },
  newSidebar: {
    order: 2,
    min: 18.5,
    max: 32,
    defaultSize: 25.5,
  },
  devtools: {
    order: 2,
    min: 30,
    max: 60,
    defaultSize: 30,
  },
};

export default PanelSizes;
